<template>
    <div>
        <div class="text-info-block mt-4 mb-4">
            <div>
                <h3 class="text-info-title pt-4"> Central de atendimento </h3>
                <hr class="mt-0">
                <div v-if="menu.length">
                    <div v-for="(item, index) in menu" :key="index" class="d-flex justify-content-between align-items-baseline mb-3">
                        <component :is="isExternalLink(item.href) ? 'a' : 'nuxt-link'" v-bind="isExternalLink(item.href) ? {href: item.href} : {to: item.href}" :target="item.target" :title="item.name" class="text-info-link" :class="$route.path == item.href ? 'isActive' : ''">{{ item.name }}</component>
                        <div v-if="$route.path == item.href">
                            <b-icon icon="caret-right-fill" :class="$route.path == item.href ? 'icon-active' : ''"></b-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-info-doubt mb-5 pr-3 pl-3 pt-4 pb-4" v-if="additional_block">
            <div class="text-info-doubt-title mb-3 mt-3" v-if="'name1' in additional_block"> {{ additional_block.name1 }} </div>
            <div v-if="'text1' in additional_block" class="text-info-doubt-text mb-1" v-html="additional_block.text1"></div>
        </div>
    </div>
</template>
<script>
import utils from "~/mixins/utils";

export default {
    props: {
        content: {},
        additional_block: {}
    },
    mixins: [
        utils
    ],
    data(){
        return{
            menu: [],
        }
    },
    async fetch() {
        this.menu = await this.$axios.$get(`/api/v1/menu/?area=4`).then((res) => {
            return res.data
        });
        this.additional_block = await this.$axios.$get(`api/v1/cms/?page_alias=bloco-de-informacoes`).then((res)=>{
            return res.data
        })
    }
}
</script>
